<script lang="ts"></script>

<style lang="scss">
  :host {
    display: block;
  }
</style>
